import { RetailerPartnerType } from '../enum/index.js';
const config = {
    type: RetailerPartnerType.AMAZON_FRESH
};
export default config;
